// import PatentSearch from "../assets/img/website_03.png";
// import PatentDraft from "../assets/img/website_02.png";
// import DesignPatent from "../assets/img/website_01.png";
// import CopyRightServices from "../assets/img/website_04.png";
// import TrademarkServices from "../assets/img/website_05.png";
// import GeographicalIndication from "../assets/img/GI.png";
const subServiceContent = {

  patent: {
    title: "Patent",
    subtitle: "Secure What Sets You Apart",
    description:[
      "At every stage of innovation, securing intellectual property is critical to long-term success. with a focus on both legal strength and strategic positioning, LifeIntelect delivers end-to-end patent services—from early assessment and drafting to global filings and enforcement. Businesses and innovators gain more than protection; they unlock the commercial value of their ideas through a framework designed for growth, compliance, and competitive edge.",
      "Innovation deserves more than just recognition—it requires legal protection and strategic positioning. Patent protection acts as a powerful business tool, safeguarding competitive advantage and enhancing investor appeal across markets."],
    patent_info: {
      title: "What is a Patent and Why Patents Matter for Business?",
      description:
        "A patent is an exclusive legal right granted to an inventor, allowing them to prevent others from making, using, selling, or distributing their invention for a specific period—typically 20 years from the date of filing.",
      typesSection: {
        Heading: "To qualify for a patent, an invention must be:",
        types: [
          {
            title: "Novel",
            description: "It must not have been disclosed publicly.",
          },
          {
            title: "Inventive",
            description: "It must be non-obvious to others in the field.",
          },
          {
            title: "Industrially applicable",
            description: "It must be capable of being used in industry.",
          },
        ],
      },
      advantages: {
        Heading: "Advantages: ",
         types: [
        {
          title: "Exclusive rights to innovate",
          description:
            "Prevent unauthorized use, manufacture, or sale of your invention.",
        },
        {
          title: "Investor-ready IP",
          description:
            "Strengthens credibility during funding and acquisition discussions.",
        },
        {
          title: "Monetization routes",
          description:
            "Opens doors for licensing, joint ventures, and strategic alliances.",
        },
        {
          title: "Global footprint",
          description:
            "Facilitates expansion into international markets with confidence.",
        },
      ],
    },
    },
    service_1: {
      title: "Patent Search",
      subtitle: "Know Before You File",
      description:
        "Understanding the global IP landscape helps avoid costly surprises. A detailed search can clarify patentability, assess risks, and guide your filing strategy.",
      processTitle: "Critical Search Solutions:",
      process: [
        {
          title: "Patentability Search",
          description: "Checks novelty and uniqueness using global databases",
        },
        {
          title: "Freedom to Operate (FTO):",
          description: "Identifies risks of infringement in key markets",
        },
        {
          title: "Validity/Invalidity Search",
          description:
            "Evaluates enforceability or challenges competitor claims",
        },
        {
          title: "Technology Landscape Mapping:",
          description: "Reveals innovation trends and whitespace opportunities",
        },
      ],
        // typesSection: {
        //   image: PatentSearch,
        //   types: [
        //     {
        //       title: "Patentability Search",
        //       description:
        //         "Our patentability search determines whether an invention is novel and patentable before applying for patent protection. Our experts conduct a thorough search of global patent databases and other relevant sources to find any prior art similar to the invention. This helps us evaluate the novelty and potential patentability of the invention. Conducting a patentability search helps in drafting a strong patent specification that highlights the true novelty and usefulness of the invention. We provide full documentation of all patentability searches in the form of a patent search report, which includes detailed analysis and recommendations.",
        //     },
        //     {
        //       title: "Freedom to Operate (FTO) Search",
        //       description:
        //         "A freedom to operate (FTO) search and analysis determine the risk of patent infringement in a particular jurisdiction before launching a product or using a process. Our experts perform a comprehensive search of patent literature for issued or pending patents and obtain a legal opinion on whether a product, process, or service may infringe existing patents owned by others. An FTO search and analysis help businesses mitigate the risk of patent infringement and identify potential opportunities for collaboration or licensing. We provide a detailed FTO search report that includes an analysis of potential infringement risks and recommendations for proceeding.",
        //     },
        //     {
        //       title: "Validity or Invalidity Search",
        //       description:
        //         "A validity or invalidity search identifies prior art that could invalidate or challenge the validity of a granted patent. Our experts conduct a comprehensive search of all publicly available valid documents, including patents, scientific literature, and other relevant sources. We perform detailed research and claim mapping to assess the validity or invalidity of a granted patent. A validity or invalidity search helps patent holders defend their patents against challenges or oppositions and assists in challenging the validity of competitors' patents, providing a strategic advantage in the market. We provide a detailed search report that includes an analysis of relevant prior art and recommendations for proceeding with validity or invalidity claims.",
        //     },
        //     {
        //       title: "State of the Art or Technology Landscape Analysis",
        //       description:
        //         "A state-of-the-art or technology landscape analysis helps clients understand the evolution of a particular technology and the overall technology trends in multiple domains. Our experts conduct a comprehensive search and analysis of patent literature, scientific publications, and other relevant sources to identify technological trends, major players, and competitors' strengths. We analyse patent activities related to the technology of interest. A state-of-the-art or technology landscape analysis provides valuable insights into the technological advancements and competitive landscape, helping clients formulate R&D strategies, plan product launches, and understand competitors' strategies. We provide a detailed analysis report that includes insights into technology trends, major players, and recommendations for strategic decision-making.",
        //     },
        //   ],
        // },
    },
    service_2: {
      title: "Patent Drafting",
      subtitle: "Build Strong Claims from the Start",
      description:
        "The strength of a patent lies in its drafting. Clear, comprehensive claims and technical descriptions ensure broader protection and reduced risk of design-arounds.",
      // image: PatentDraft,
      typesSection: {
        manualHeading: "Essentials of High-Quality Drafting:",
        types: [
          {
            title: "Provisional & Complete Specifications",
            description: "Tailored to product stage and market need",
          },
          {
            title: "Patent Illustrations",
            description:
              "Professionally prepared and compliant with global standards",
          },
          {
            title: "PCT-Ready Documents",
            description: "Drafted to streamline international filings",
          },
          {
            title: "Office Action Responses",
            description: "Strategically worded to overcome objections",
          },
        ],
      },
    },

    service_3: {
      title: "Patent Filing",
      subtitle: "Navigate Local and Global Systems with Ease",
      description:
        "Filing patents can be complex—but with the right framework, the process becomes seamless. From documentation to multi-jurisdictional filings, a systematic approach ensures deadlines and requirements are never missed.",
      subsections: [
        {
          heading: "Filing Support Includes:",
          items: [
            {
              title: "Jurisdiction strategy",
              description: "Aligns with your markets and product rollout",
            },
            {
              title: "Document preparation",
              description:
                "Includes provisional, complete, and PCT applications",
            },
            {
              title: "Ongoing updates",
              description: "Tracks application status and changes",
            },
            {
              title: "Compliance and timelines",
              description: "Ensures accurate, on-time submissions globally",
            },
          ],
        },
      ],
    },
    service_4: {
      title: "Patent Prosecution",
      subtitle: "Move from Application to Grant Smoothly",
      description:
        "The journey from filing to approval involves back-and-forth with patent offices. Proactive prosecution accelerates this process while safeguarding your invention’s full potential.",
      subsections: [
        {
          heading: "What Effective Prosecution Involves:",
          items: [
            {
              title: "Examination tracking",
              description: "Monitors office actions and application progress",
            },
            {
              title: "Legal and technical responses",
              description: "Addresses objections with precision",
            },
            {
              title: "Claim refinement",
              description: "Strengthen scope while preserving uniqueness",
            },
            {
              title: "Direct engagement with examiners",
              description: "Facilitates faster and favorable outcomes",
            },
          ],
        },
      ],
    },
    service_5: {
      title: "Patent Maintenance",
      subtitle: "Keep Protection Active—Effortlessly",
      description:
	  "A granted patent needs periodic renewals and compliance tracking to stay in force. Missed deadlines can mean lost rights—and lost revenue.",
      subsections: [
        {
          heading: "Maintenance Made Simple:",
          items: [
            {
              title: "Deadline monitoring",
              description:
                "Avoids lapses with timely alerts",
            },
            {
              title: "Renewal fee calculations and submissions",
              description:
                "Adjusted per jurisdiction",
            },
            {
              title: "Regulatory tracking",
              description:
                "Stays ahead of fee or process changes",
            },
			{
              title: "Portfolio upkeep",
              description:
                "Ensures alignment with evolving business goals",
            },
          ],
        },
      ],
    //   closing:
    //     "With Lifeintelect, you can focus on leveraging your innovation while we take care of the administrative complexities of patent maintenance. Trust us to keep your patents active and enforceable, safeguarding your valuable intellectual property. Ready to ensure your patents stay protected? Let's get started!",
    },
    // service_6: {
    //   title: "NBA Approval",
    //   description:
    //     "At LifeIntelect Consultancy, we offer an additional service to assist clients in securing approval from the National Biodiversity Authority (NBA) for intellectual property (IP) involving biological materials. Our Patent team is highly knowledgeable about the National Biodiversity Act and its implications for Patent Law. We thoroughly evaluate your invention to determine if NBA approval is required and provide expert advice on the necessary steps to comply with regulations. Our comprehensive support includes preparing and submitting the required documentation to the NBA, such as research proposals and consent letters. By partnering with LifeIntelect Consultancy, you can ensure that your IP filings involving biological resources are compliant with national standards and protected under the law. This service adds an extra layer of security and compliance, giving you the confidence to innovate and contribute to the sustainable use of India's rich biodiversity.",
    //   subsections: [
    //     {
    //       heading: "NBA Filing",
    //       description:
    //         "At Lifeintelect we ensure that all necessary steps for NBA (National Biodiversity Authority) compliance are followed meticulously. Here’s the process we follow:",
    //       steps: [
    //         {
    //           title: "Assessing Biological Resource Use",
    //           description:
    //             "First, we assess the biological resource used in the invention, ensuring that it involves any plant, animal, microbial, or genetic material that requires NBA approval. We confirm if the biological resource is sourced from India or has been accessed through traditional knowledge.",
    //         },
    //         {
    //           title: "Documenting the Origin of Biological Resources",
    //           description:
    //             "We collect and document detailed information about the biological resources used in the invention.",
    //           subPoints: [
    //             "The exact source of the biological material (e.g., from nature, research institutions, or indigenous communities).",
    //             "The method of collection or acquisition.",
    //             "Any agreements related to the collection (e.g., Memorandum of Understanding (MoU) with local communities).",
    //           ],
    //         },
    //         {
    //           title: "Filing the NBA Application",
    //           description: "We prepare and file an application with the NBA.",
    //           subPoints: [
    //             "Detailed descriptions of the invention and how biological resources are used.",
    //             "Proof of prior approval from the NBA (if required) for accessing biological resources.",
    //             "A declaration of compliance with the Biodiversity Act and relevant regulations.",
    //           ],
    //         },
    //         {
    //           title: "Follow-up with the NBA",
    //           description:
    //             "After submission, we monitor the application’s progress and work closely with the NBA to address any queries or additional documentation they may require. We ensure that all formalities are completed promptly and the approval process is smooth.",
    //         },
    //         {
    //           title: "Compliance and Reporting",
    //           description:
    //             "Once the patent is granted and the biological resource use is approved, we ensure that all ongoing compliance requirements are met. This could include reporting to the NBA about how the resource is being used or any modifications to the invention.",
    //         },
    //       ],
    //     },
    //   ],
    // },
  },

  design: {
    title: "Industrial Design",
     subtitle: "Protect the Visual Identity That Defines Your Brand",
    description:
      "Industrial design goes beyond aesthetics—it builds market presence, shapes customer perception, and drives competitive edge. Safeguarding product appearance through design rights is essential to prevent imitation and preserve originality. Whether launching a breakthrough product or expanding globally, design protection offers a strategic legal shield that complements innovation.",
    patent_info: {
      title: "What is an Industrial Design?",
      description:
        "An industrial design protects the unique visual aspects of a product—its shape, surface patterns, configuration, or ornamentation—that appeal to the eye. These elements do not protect function but are critical to brand identity and customer preference.",
      typesSection: {
        Heading: "What Sets Design Protection Apart",
        types: [
          {
            title: "Non-functional features",
            description: "Protection is granted for visual appearance, not functionality.",
          },
          {
            title: "Novel and original",
            description: "The design must be new and not previously disclosed.",
          },
          {
            title: "Applicable across industries",
            description: "Recognized in fashion, tech, packaging, tools, and more.",
          },
        ],
      },
    },
    service_1: {
      title: "Design Drafting",
      subtitle: "Turn concepts into compelling, compliant design assets",
      description:
        "Our team captures the true essence of your product visually and documents it to ensure your design is registered successfully.",
      typesSection: {
        manualHeading: "What Effective Drafting Involves:",
        types: [
          {
            title: "High-Precision Illustrations",
            description: "Multi-angle drawings that meet global IP office standards.",
          },
          {
            title: "Descriptive Clarity",
            description: "Detailed write-ups highlighting your design’s unique features.",
          },
          {
            title: "Strategic Positioning",
            description: "Your application is prepared for strong, swift registration outcomes.",
          },
        ],
      },
    },
    service_2: {
      title: "Design Filing",
      subtitle: "File smarter, faster, and across borders",
      description:
        "Navigating design registrations becomes seamless with our expertise, ensuring your designs are protected globally.",
      typesSection: {
        manualHeading: "What Smart Filing Delivers:",
        types: [
          {
            title: "Formal Application Drafting",
            description: "Precise and compliant documentation.",
          },
          {
            title: "Seamless Submission & Compliance Management",
            description: "Smooth, timely filings with IP offices worldwide.",
          },
          {
            title: "Global Reach through Hague System (WIPO)",
            description: "Streamlined international protection for your designs.",
          },
        ],
      },
    },
    service_3: {
      title: "Design Prosecution",
      subtitle: "Expert advocacy when it counts",
      description:
        "From responding to objections to handling complex queries, the prosecution process for your design application is managed with precision.",
      typesSection: {
        manualHeading: "What Strategic Prosecution Involves:",
        types: [
          {
            title: "Office Action Responses",
            description: "Clear and well-supported replies to objections.",
          },
          {
            title: "Technical & Legal Argumentation",
            description: "Tailored responses to overcome examiner concerns.",
          },
        ],
      },
    },
    service_4: {
      title: "Design Maintenance",
      subtitle: "Sustain your protection, effortlessly",
      description:
        "Your design rights need regular upkeep to remain active. Protection for your design remains ensured throughout its lifespan.",
      typesSection: {
        manualHeading: "Maintenance Made Easy:",
        types: [
          {
            title: "Renewal Monitoring & Timely Reminders",
            description: "Prevents lapses in protection.",
          },
          {
            title: "Jurisdiction-Specific Fee Management",
            description: "Handles varied fee structures across regions.",
          },
          {
            title: "Regulatory Compliance Support",
            description: "Keeps you ahead of evolving regulations.",
          },
        ],
      },
    },
    service_5: {
      title: "Design Portfolio Management",
      subtitle: "Organize, Monitor, and Maximize Your Design Assets",
      description:
        "Managing multiple designs becomes effortless with your streamlined and organized portfolio approach.",
      typesSection: {
        manualHeading: "Effective Management through:",
        types: [
          {
            title: "Centralized Asset Monitoring",
            description: "Keep track of your entire design portfolio.",
          },
          {
            title: "Infringement & Competitor Mapping",
            description: "Identify risks and monitor market activity.",
          },
          {
            title: "Renewal Planning & Optimization",
            description: "Ensure timely renewals and fee management for long-term protection.",
          },
        ],
      },
    },
    service_6: {
      title: "Design Risk Assessment",
      subtitle: "Launch with clarity. Expand without fear.",
      description:
        "Entering the market with a solid design strategy starts with proactive risk assessment.",
      typesSection: {
        manualHeading: "What you’ll Benefit from:",
        types: [
          {
            title: "Competitor Landscape Analysis",
            description: "Understand your market position.",
          },
          {
            title: "Infringement Risk Assessments",
            description: "Evaluate potential infringement issues before launching.",
          },
          {
            title: "Strategic Market Entry Insights",
            description: "Tailor your design strategy for successful market introduction.",
          },
        ],
      },
    },
    service_7: {
      title: "Design Audit",
      subtitle: "Unlock the Full Potential of Your Design Portfolio",
      description:
        "Get a clear view of your design assets’ value, gaps, and growth opportunities.",
      typesSection: {
        manualHeading: "Audit Essentials Include:",
        types: [
          {
            title: "Complete Portfolio Review",
            description: "Comprehensive evaluation of your entire design portfolio.",
          },
          {
            title: "Gap & Risk Analysis",
            description: "Identify weaknesses and potential areas for enhancement.",
          },
          {
            title: "Strategic Enhancement Roadmap",
            description: "Develop a plan to boost the value and protection of your design assets.",
          },
        ],
      },
    },
  },

copyright: {
    "title": "Copyright",
    "subtitle": "Protect What You Create. Preserve What You Own.",
    "description": "In the digital economy, originality is currency—and without protection, your work is vulnerable. Copyright secures your exclusive rights over original content like software, digital media, literature, music, training modules, and more. Whether it's code or a creative asset, copyright enables control over usage, reproduction, licensing, and monetization.",
    "patent_info": {
      "title": "What is Copyright and Why is it essential?",
      "description": [
      "Copyright is a legal right that grants creators exclusive ownership and control over their original works — from literature, music, and software, to digital content, design, and more. It protects the expression of ideas, not the ideas themselves, and ensures that you, as the creator, control how your work is used, reproduced, distributed, or monetized.",
      " without proper protection, your original work is at risk of being copied, misused, or exploited without your permission. By securing copyright, you not only establish legal ownership, but also gain the ability to license, commercialize, and enforce your rights across markets."
    ]
    },
    "service_1": {
      "title": "Copyright Filing & Registration",
      "subtitle": "Secure Ownership. Simplify Compliance.",
      "description": "Smooth registration is the first step to enforceable rights. A well-prepared copyright application avoids delays and reinforces legal certainty.",
      "typesSection": {
        manualHeading: "What Effective Filing Involves:",
        "types": [
          {
            "description": "Tailored application drafting based on content type and jurisdiction."
          },
          {
            "description": "Procedural compliance with Indian and global copyright frameworks."
          },
          {
            "description": "Documentation accuracy to reduce rejections and delays."
          },
          {
            "description": "Real-time tracking to ensure smooth process flow."
          }
        ]
      }
    },
    "service_2": {
      "title": "Legal Opinions & Strategic Guidance",
      "subtitle": "Navigate Complexity with Clarity.",
      "description": "Uncertainty around originality, ownership, or fair use can expose your content to risk. Strategic legal guidance clarifies your position and informs business decisions.",
      "typesSection": {
        manualHeading: "What Strategic Guidance Covers:",
        "types": [
          {
            "description": "Ownership and originality assessments for your content."
          },
          {
            "description": "Legal clarity on derivative works and fair use boundaries."
          },
          {
            "description": "Strategic licensing or publishing advice",
          },
          {
            "description": "Hybrid IP insights for software, content, or creative portfolios."
          }
        ]
      }
    },
    "service_3": {
      "title": "Response to Copyright Objections",
      "subtitle": "Overcome Hurdles. Move Forward Confidently.",
      "description": "When procedural objections or legal issues arise during copyright examination, timely and precise responses keep your application on track.",
      "typesSection": {
        manualHeading: "What Objection Response Involves:",
        "types": [
          {
            "description": "Drafting of technical and legal replies to examiner objections."
          },
          {
            "description": "Submission of supportive documentation and evidence."
          },
          {
            "description": "Communicating with the Copyright office for resolution."
          },
          {
            "description": "Minimizing disruption to your enforcement timeline."
          }
        ]
      }
    },
    "service_4": {
      "title": "Online Risk Assessment",
      "subtitle": "Detect Infringement Before It Escalates.",
      "description": "Digital content is highly susceptible to unauthorized replication. Proactive risk management helps you identify and act on infringements quickly.",
      "typesSection": {
        manualHeading: "What Digital Risk Management Covers:",
        "types": [
          {
            "description": "Ongoing surveillance across web, marketplaces, and social media."
          },
          {
            "description": "Detection of unlicensed reproductions reposts, or theft."
          },
          {
            "description": "Measures to maintain your content integrity online."
          }
        ]
      }
    },
    "service_5": {
      "title": "Content Monitoring & Enforcement",
      "subtitle": "Maintain Visibility. Enforce Your Rights.",
      "description": "A clear view of your content’s digital footprint enables faster, more effective enforcement actions and informed licensing strategies.",
      "typesSection": {
        manualHeading: "What Enforcement Support Includes:",
        "types": [
          {
            "description": "Real-time usage tracking and reporting of your content."
          },
          {
            "description": "Detection of unauthorized access or distribution."
          },
          {
            "description": "Escalation pathways from cease-and-desist to litigation."
          },
          {
            "description": "Licensing support where infringement can be converted to opportunity."
          }
        ]
      }
    },
    "service_6": {
      "title": "Digital Rights Management (DRM)",
      "subtitle": "Control Digital Access. Prevent Piracy.",
      "description": "Digital delivery demands strong control mechanisms. DRM protects your digital IP while enabling secure access.",
      "typesSection": {
        manualHeading: "What DRM Solutions Deliver:",
        "types": [
          {
            "description": "Strategy development for software, e-learning, media & content."
          },
          {
            "description": "Encryption, watermarking and anti-piracy controls."
          },
          {
            "description": "Access governance and user behaviour restriction."
          },
          {
            "description": "Legal readiness to respond to unauthorized sharing."
          }
        ]
      }
    },
    "service_7": {
      "title": "Copyright Audits & Portfolio Optimization",
      "subtitle": "Know What You Own. Strengthen What You Have.",
      "description": "An organized copyright portfolio is key to IP leverage. Audits help uncover blind spots and boost asset value.",
      "typesSection": {
        manualHeading: "What Portfolio Optimization Offers:",
        "types": [
          {
            "description": "Full asset inventory and protection review."
          },
          {
            "description": "Gap identification and risk mitigation."
          },
          {
            "description": "Streamlined documentation and renewal tracking."
          },
          {
            "description": "Forward-looking strategies to scale protection with growth."
          }
        ]
      }
    }
  },

  trademark: {
    subtitle: "Own Your Brand. Defend Its Value.",
    title: "Trademark",
    description:
      "Your trademark is more than a logo or name—it’s a powerful business asset that defines your market presence, builds customer trust, and protects your identity from misuse. At LifeIntelect, we safeguard your brand from the ground up with precision-driven, end-to-end trademark services.",
    patent_info: {
      title: "What Is a Trademark — and Why Is Protecting It Vital for Your Brand?",
      description:[
        "A trademark is a unique symbol, name, or design that distinguishes your brand and products. It ensures consumers can easily identify and trust your offerings.",
        " In a competitive global market, your brand is vulnerable to imitation or misuse. Securing trademark rights early protects your legal ownership, strengthens your market position, and opens doors for future growth, licensing, and enforcement. Protecting your trademark is key to safeguarding your brand’s reputation and long-term success."],
    },
    service_1: {
      title: "Trademark Search & Risk Analysis",
      subtitle : "Know Before You File. Avoid Costly Pitfalls",
      description:
        "Filing without insight invites risk. Get a clear picture of the legal landscape before investing in branding.",
      typesSection: {
        manualHeading: "What Strategic Search Involves:",
        types: [
          {
            description: "Comprehensive checks across Indian and International trademark databases.",
          },
          {
            
            description: "Conflict analysis with existing or similar marks.",
          },
          {
            description: "Trademark registrability opinion with actionable insights.",
          },
          {
            description: "Legal risk assessment To flag potential oppositions or challenges.",
          },
        ],
      },
    },
    service_2: {
      title: "Trademark Filing & Registration",
      subtitle: "File with Confidence. Register with Precision.", 
      description:
        "A well-prepared application is key to smooth approval and long-term protection.",
      typesSection: {
        manualHeading: "What Filing Includes:",
        types: [
          {
            description: "Drafting accurate descriptions and trademark classifications.",
          },
          {
            description: "National and international procedural compliance.",
          },
          {
            description: "Filing through Indian TM Registry Madrid System (WIPO), and others.",
          },
          {
            description: "Government fee management and end-to-end process tracking.",
          },
        ],
      },
    },
    service_3: {
      title: "Trademark Prosecution & Renewal",
      subtitle: "Turn Objections Into Progress. Extend Your Rights Seamlessly.",
      description:
        "Trademark offices may raise objections. Ensure your application stays on track with legal and technical clarity.",
      typesSection: {
        manualHeading: "What Prosecution Support Covers:",
        types: [
          {
            description: "Legal responses to examiner objections.",
          },
          {
            description: "Compilation of evidence arguments, and clarifications.",
          },
          {
            description: "Communication with trademark authorities.",
          },
          {
            description: "Trademark renewal tracking and timely filings.",
          },
        ],
      },
    },
    service_4: {
      title: "Opposition & Rectification",
      subtitle: "Challenge Misuse. Defend What’s Yours",
      description:
        "Whether you're defending your mark or contesting a competitor’s, our legal experts deliver targeted, strategic action.",
      typesSection: {
        manualHeading: "What Dispute Support Includes:",
        types: [
          {
            description: "Filing of oppositions rectifications, and cancellations.",
          },
          {
            description: "Legal representation in trademark tribunals.",
          },
          {
            description: "Case-by-case strategy based on jurisdiction and commercial goals.",
          },
        ],
      },
    },
    service_5: {
      title: "Trademark Portfolio Management",
      subtitle: "Centralize Oversight. Maximize Brand Impact",
      description:
        "As your brand footprint grows, so does the need for strategic oversight of your trademark portfolio.",
      typesSection: {
        manualHeading: "What Portfolio Management Provides:",
        types: [
          {
            description: "Central tracking of all trademarks and renewals.",
          },
          {
            description: "Jurisdiction-specific updates and compliance monitoring.",
          },
          {
            description: "Alignment of trademark coverage with evolving business goals.",
          },
        ],
      },
    },
    service_6: {
      title: "Trademark Watch & Enforcement",
      subtitle: "Detect Infringement Early. Take Action Decisively",
      description:
        "Trademark misuse can erode your brand’s value. Watch services help monitor the market and enable fast, effective enforcement to protect your rights.",
      typesSection: {
        manualHeading: "What Enforcement Includes:",
        types: [
          {
            description: "Monitoring of trademark registries and digital platforms.",
          },
          {
            description: "Early identification of similar or infringing marks.",
          },
          {
            description: "Legal action planning: oppositions, cease-and-desist, or litigation",
          },
        ],
      },
    },
  },

  geographicalIndications: {
  title: "Geographical Indication (GI)",
  subtitle: "Preserve Origin. Protect Heritage. Empower Local Economies.",
  description:
    "A Geographical Indication (GI) isn’t just a legal tool — it’s a marker of tradition, quality, and cultural identity. At LifeIntelect Consultancy, we help producer groups, cooperatives, and regional organizations secure, protect, and enforce GI rights through technolegal expertise and strategic support.",

  patent_info: {
    title: "What Is a GI?",
    description:
      "A Geographical Indication is a certification granted to products that originate from a specific region and derive their distinct qualities or reputation from that location. Under India’s Geographical Indications of Goods (Registration and Protection) Act, 1999, GIs offer legal exclusivity, boost brand recognition, and support economic sustainability for traditional producers.",
     sub_info: {
      subtitle1: "GI status = Authenticity + Market Differentiation + Legal Protection",
      subtitle2:"Why Geographical Indication (GI) Protection Matters?",
      description1:["A Geographical Indication (GI) is more than a label—it's a seal of authenticity, linking your product’s unique qualities to its region of origin. GI protection helps safeguard cultural identity, enhance product value, and support local economies",
        "In a global market, protecting your GI ensures exclusivity, builds consumer trust, and prevents misuse. It’s your legal tool to promote traditional knowledge and empower community-based commerce for long-term growth."
      ],
    },
  },


  service_1: {
    title: "GI Search & Analysis",
    subtitle:"Know Your Eligibility. Maximize Your Advantage.",
    description:
      "Before registering, assess whether your product qualifies as a GI—and how it can be best positioned for protection.",
    typesSection: {
      manualHeading: "What the Feasibility Process Covers:",
      types: [
        { description: "Comprehensive search of existing GI registrations and market records." },
        { description: "Legal evaluation of origin-linked qualities and production methods." },
        { description: "Expert opinions on registrability, uniqueness, and protection scope." },
        { description: "Advisory on group eligibility and documentation requirements." },
      ],
    },
  },

  service_2: {
    title: "GI Filing & Registration",
    subtitle: "File Confidently. Protect What Sets You Apart.",
    description:
      "GI filing requires precision and strong origin-based documentation. Protect your product with a robust, compliant application.",
    typesSection: {
      manualHeading: "What GI Filing Includes:",
      types: [
        { description: "Drafting of detailed statements of case and technical specifications." },
        { description: "Collation of origin evidence, production methods, and community support." },
        { description: "Filing with the GI Registry (Chennai) or via international routes." },
        { description: "Coordination with producers’ associations and state departments." },
        { description: "Government fee handling and milestone tracking." },
      ],
    },
  },

  service_3: {
    title: "GI Prosecution & Renewal",
    subtitle: "Address Objections. Sustain Protection Over Time.",
    description:
      "If objections arise during examination, timely and strategic response ensures continued progress and long-term protection.",
    typesSection: {
      manualHeading: "What GI Prosecution Support Offers:",
      types: [
        { description: "Legal drafting of replies to examination reports." },
        { description: "Representation during registrar hearings." },
        { description: "Submission of expert reports or field documentation." },
        { description: "Lifecycle renewal management to maintain GI rights." },
      ],
    },
  },

  service_4: {
    title: "GI Opposition & Rectification",
    subtitle: "Defend Your Recognition. Challenge Improper Claims.",
    description:
      "Disputes or improper GI filings can dilute your product’s value. Act swiftly to secure your rights.",
    typesSection: {
      manualHeading: "Opposition & Rectifications",
      types: [
        { description: "Opposition to conflicting or misleading GIs." },
        { description: "Legal correction of inaccurate registrations." },
        { description: "Strategic resolution of market conflicts." },
      ],
    },
  },

  service_5: {
    title: "GI Portfolio Management",
    subtitle: "Scale Strategically. Maintain Oversight.",
    description:
      "As your GI registrations expand across categories or jurisdictions, structured portfolio management becomes essential.",
    typesSection: {
      manualHeading: "Our Portfolio Services Include:",
      types: [
        { description: "Tracking of renewal dates and regulatory deadlines." },
        { description: "Organizing documents for audits, exports, or marketing use." },
        { description: "Legal reviews to ensure compliance." },
        { description: "Advisory on extension of GI protection in foreign markets." },
      ],
    },
  },

  service_6: {
    title: "Risk Assessment & Enforcement Strategy",
    subtitle: "Guard Against Infringement. Take Action When Needed.",
    description:
      "Even registered GIs face threats from misuse, imitation, or dilution. Our enforcement approach is proactive and actionable.",
    typesSection: {
      manualHeading: "What Risk Management Involves:",
      types: [
        { description: "Market and competitor analysis to detect misuse." },
        { description: "Legal mapping of confusingly similar trademarks or branding." },
        { description: "Creation of enforcement plans: cease-and-desist, customs action, litigation." },
        { description: "Strategic coordination with local authorities, NGOs, and industry bodies." },
      ],
    },
  },
},

nba_approval: {
  title: "NATIONAL BIODIVERSITY AUTHORITY (NBA) APPROVAL",
  subtitle:"Ensure Compliance. Protect Innovation. Advance Ethically. ",
  description:[
    "When innovation draws from India’s biological wealth — be it plants, microorganisms, or traditional knowledge — NBA (National Biodiversity Authority) approval becomes more than a formality. It is a legal mandate under the Biological Diversity Act, 2023, and a foundational step in safeguarding ethical and compliant IP protection.",
    " Technolegal clarity ensures a smooth transition from discovery to disclosure — enabling responsible research, lawful commercialization, and stronger global positioning."],

  patent_info: {
    title: "⚖️ Why NBA Compliance Matters",
    description:
      "Biological resources and associated knowledge in India are safeguarded under national law. Any innovation involving access to these elements must be reviewed and approved by the NBA before seeking IP protection or entering the market.",
      typesSection: {
        Heading: "🔒 Without NBA Approval:",
        types: [
          {
            description: "IP rights may face invalidation.",
          },
          {
            description: "Regulatory penalties can be imposed",
          },
          {
            description: "Legal challenges may arise from communities or institutional stakeholders",
          },
        ],
              description1: "NBA compliance strengthens the credibility and commercial viability of the invention, especially in international transactions, patent filings, and benefit-sharing arrangements.",
      },
  },

  

  service_1: {
    title: "Invention Assessment & Applicability Check",
    subtitle: "Is NBA Approval Required?",
    description:
      "Before proceeding with any filing or commercialization, it’s essential to determine whether an invention falls within NBA jurisdiction. This assessment eliminates ambiguity and aligns early-stage development with legal frameworks.",
    typesSection: {
      manualHeading: "Key considerations include:",
      types: [
        { description: "Presence of biological material sourced from India." },
        { description: "Inclusion of traditional knowledge in the invention process." },
        { description: "Sector-specific application (e.g. biotech, pharma, agriculture, cosmetics)." },
      ],
    },
  },

  service_2: {
    title: "Documentation & Source Verification",
    subtitle: "",
    description:
      "NBA applications require verifiable documentation of how biological material or traditional knowledge was accessed and utilized. A well-documented case strengthens both legal defensibility and community trust.",
    typesSection: {
      manualHeading: "Information typically includes:",
      types: [
        { description: "Source origin (wild collection, research institution, or community-based)." },
        { description: "Method of acquisition or transfer." },
        { description: "Supporting legal agreements (e.g. MoUs, Material Transfer Agreements, ABS agreements)." },
        { description: "Purpose of use and intended commercial or research benefits." },
      ],
    },
  },

  service_3: {
    title: "Application Drafting & Submission",
    subtitle: "",
    description:
      "An effective application communicates both technical intent and legal compliance. Every section — from invention disclosure to benefit-sharing declarations — is tailored to align with NBA evaluation standards.",
    typesSection: {
      manualHeading: "Typical submission elements include:",
      types: [
        { description: "Role of biological resource in the claimed invention." },
        { description: "Details on processing, application, or commercial potential." },
        { description: "Access permissions and benefit-sharing declarations." },
        { description: "Documentation of prior approvals or intent to comply." },
      ],
    },
  },

  service_4: {
    title: "Liaison & Regulatory Coordination",
    description:
      "Following submission, regulatory queries or clarifications are common. Active communication with NBA authorities ensures that the application remains on track.",
    typesSection: {
      manualHeading: "Key responsibilities involve:",
      types: [
        { description: "Timely response to examiner communications." },
        { description: "Clarification of legal or scientific disclosures." },
        { description: "Submission of supplementary documentation, if required." },
        { description: "Continuous tracking of approval milestones." },
      ],
    },
  },

  service_5: {
    title: "Post-Approval Compliance",
    description:
      "NBA approval marks the beginning — not the end — of compliance obligations. Sustained alignment is essential to avoid penalties, preserve IP rights, and uphold community benefit agreements.",
    typesSection: {
      manualHeading: "Post-approval requirements may include:",
      types: [
        { description: "Periodic usage reporting to NBA." },
        { description: "Notifications regarding changes in usage or ownership." },
        { description: "Fulfillment of benefit-sharing commitments." },
        { description: "Coordination of disclosures for future filings or audits." },
      ],
    },
  },
},


  
};

export default subServiceContent;
